import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

import type { PieChartHoveredState } from './types'

export interface PieChartContextType {
  /**
   * Width of the chart container.
   */
  width: number
  /**
   * Height of the chart container.
   */
  height: number
  /**
   * State of the hovered slice.
   */
  hovered: PieChartHoveredState | null
  /**
   * Sets the state of the hovered slice.
   */
  setHovered: Dispatch<SetStateAction<PieChartHoveredState | null>>
  /**
   * State of the hovered tooltip.
   */
  tooltipHovered: PieChartHoveredState | null
  /**
   * Sets the state of the hovered tooltip.
   */
  setTooltipHovered: Dispatch<SetStateAction<PieChartHoveredState | null>>
  /**
   * Slice colors.
   */
  colors: string[]
}

export const PieChartContext = createContext<PieChartContextType | null>(null)
